import React from 'react';
import { Menu, X } from 'lucide-react';
import '../styles/Download.scss';
import logotextblack from '../assets/logotextblack.png';

const POPULAR_EVENT_TYPES = [
  { name: 'Birthday', emoji: '🎂', path: 'birthday-party' },
  { name: 'Wedding', emoji: '💍', path: 'wedding' },
  { name: 'Graduation', emoji: '🎓', path: 'graduation' },
  { name: 'Baby Shower', emoji: '👶', path: 'baby-shower' },
  { name: 'Dinner', emoji: '🍽️', path: 'dinner-party' },
  { name: 'Game Night', emoji: '🎮', path: 'game-night' },
];

const Download = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const handleNavigation = (path) => {
    window.location.href = path;
  };

  const handleEventTypeClick = (eventType) => {
    handleNavigation(`/create?type=${eventType.path}`);
  };

  return (
    <div className="download-page">
      {/* Navigation */}
      <nav className="top-nav">
        <div className="nav-container">
          <div className="nav-left">
            <div className="nav-logo" onClick={() => handleNavigation('/')}>
              <img src={logotextblack} alt="Invits" className="logo-img" />
            </div>

            {/* Event Types - Desktop */}
            <div className="event-types-nav desktop-only">
              {POPULAR_EVENT_TYPES.map((type, idx) => (
                <button
                  key={idx}
                  className="event-type-btn"
                  onClick={() => handleEventTypeClick(type)}
                >
                  <span className="type-emoji">{type.emoji}</span>
                  <span className="type-name">{type.name}</span>
                </button>
              ))}
              <a href="/#cards" className="nav-link">Cards</a>
              <a href="/#studio" className="nav-link">Studio</a>
            </div>
          </div>

          <div className="nav-right">
            <button className="nav-link desktop-only" onClick={() => handleNavigation('/login')}>
              Log in
            </button>
            <button className="btn-get-app desktop-only" onClick={() => window.location.href = 'https://invits.co/app'}>
              Get the app
            </button>
            <button className="btn-create" onClick={() => handleNavigation('/create-event')}>
              Create
            </button>

            {/* Mobile Menu Toggle */}
            <button className="mobile-menu-btn mobile-only" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <button className="mobile-menu-item" onClick={() => { handleNavigation('/login'); setMobileMenuOpen(false); }}>
              Log in
            </button>
            <button className="mobile-menu-item" onClick={() => { window.location.href = 'https://invits.co/app'; setMobileMenuOpen(false); }}>
              Get the app
            </button>
            <a href="/#cards" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>💌 Cards</a>
            <a href="/#studio" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>📸 Studio</a>
            <div className="mobile-menu-divider"></div>
            <div className="mobile-menu-header">Event Types</div>
            {POPULAR_EVENT_TYPES.map((type, idx) => (
              <button
                key={idx}
                className="mobile-menu-item"
                onClick={() => { handleEventTypeClick(type); setMobileMenuOpen(false); }}
              >
                {type.emoji} {type.name}
              </button>
            ))}
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="download-hero">
        <div className="hero-container">
          {/* Left - Phone Mockup */}
          <div className="hero-visual">
            <img
              src="/images/mobile-app-mockup.png"
              alt="Invits Mobile App"
              className="phone-mockup"
            />
          </div>

          {/* Right - Download Content */}
          <div className="hero-content">
            <h1 className="download-title">Download Invits</h1>

            <div className="qr-section">
              <a href="https://invits.co/app" target="_blank" rel="noopener noreferrer" className="qr-link">
                <img
                  src="/images/appqr.svg"
                  alt="QR Code to download Invits app"
                  className="qr-code"
                />
              </a>
              <p className="qr-text">Scan this QR code with your phone to download the invits app.</p>
            </div>

            <div className="store-buttons">
              <a href="https://play.google.com/store/apps/details?id=com.app.invits" target="_blank" rel="noopener noreferrer" className="store-btn">
                <img src="/images/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
              </a>
              <a href="https://apps.apple.com/app/invits-invitations-rsvp/id6756083176" target="_blank" rel="noopener noreferrer" className="store-btn">
                <img src="/images/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer-v2">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-brand">
              <img src={logotextblack} alt="Invits" className="footer-logo" />
              <p>the new way to celebrate together</p>
            </div>

            <div className="footer-column">
              <h4>Product</h4>
              <a href="#" onClick={() => handleNavigation('/create-event')}>Event Invitations</a>
              <a href="/#cards">Greeting Cards</a>
              <a href="#" onClick={() => handleNavigation('/communities')}>Communities</a>
              <a href="#" onClick={() => handleNavigation('/explore')}>Vibe Match</a>
              <a href="/#studio">Invits Studio</a>
            </div>

            <div className="footer-column">
              <h4>Company</h4>
              <a href="#">About</a>
              <a href="#">Blog</a>
              <a href="#">Careers</a>
              <a href="/contact">Contact</a>
            </div>

            <div className="footer-column">
              <h4>Legal</h4>
              <a href="/terms-and-conditions">Terms</a>
              <a href="/privacy-policy">Privacy</a>
              <a href="#">Guidelines</a>
            </div>
          </div>

          <div className="footer-bottom">
            <p>© 2026 invits • made with 💜 for the culture</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Download;
